import React from 'react';
import { useReveal } from '../hooks/useReveal';

// variants: fadeUp, fadeIn, slideRight, slideLeft, scale
export const Reveal = ({ as: Tag = 'div', variant = 'fadeUp', delay = 0, duration = 600, className = '', children, once = true, ...rest }) => {
  const { ref, visible } = useReveal();
  const base = {
    transition: `opacity ${duration}ms cubic-bezier(0.22, 1, 0.36, 1) ${delay}ms, transform ${duration}ms cubic-bezier(0.22, 1, 0.36, 1) ${delay}ms`,
    willChange: 'opacity, transform',
  };
  const hidden = {
    fadeUp: { opacity: 0, transform: 'translateY(28px)' },
    fadeIn: { opacity: 0, transform: 'translateY(0)' },
    slideRight: { opacity: 0, transform: 'translateX(-32px)' },
    slideLeft: { opacity: 0, transform: 'translateX(32px)' },
    scale: { opacity: 0, transform: 'scale(0.96)' },
  }[variant];
  const shown = { opacity: 1, transform: 'translate(0,0) scale(1)' };
  return (
    <Tag ref={ref} className={className} style={{ ...base, ...(visible ? shown : hidden) }} {...rest}>
      {children}
    </Tag>
  );
};

export default Reveal;
